import { render } from "./j-dialog.vue?vue&type=template&id=4e3ec8ba&scoped=true"
import script from "./j-dialog.vue?vue&type=script&lang=js"
export * from "./j-dialog.vue?vue&type=script&lang=js"

import "./j-dialog.vue?vue&type=style&index=0&id=4e3ec8ba&lang=less&scoped=true"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3ec8ba"]])

export default __exports__